import '@/assets/main.css'
import 'floating-vue/dist/style.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { useI18n } from '@/i18n/index.ts'
import { usePrimeVue } from '@/primevue/index.ts'
import '@/primevue/colorMappings.css'
import piniaPluginPersistedState from 'pinia-plugin-persistedstate'
import { PiniaDebounce } from '@pinia/plugin-debounce'
import { debounce } from 'ts-debounce'

import App from '@/App.vue'
import router from '@/router'
import FloatingVue from 'floating-vue'
import { Tooltip } from 'primevue'

const app = createApp(App)
const pinia = createPinia()
pinia.use(piniaPluginPersistedState)
pinia.use(PiniaDebounce(debounce))

app.use(pinia)
app.use(router)
app.use(FloatingVue)

app.directive('resize', {
  beforeMount(el, { value = {} }) {
    // noinspection TypeScriptUnresolvedReference
    el.addEventListener('load', () => window.iFrameResize(value, el))
  },
  beforeUnmount(el) {
    // The iframe may be torn down before its load event ever fired (a modal
    // closed straight after the Forms step mounted), so there may be no
    // resizer to detach yet.
    el.iFrameResizer?.removeListeners()
  }
})
app.directive('tooltip', Tooltip)

useI18n(app)
usePrimeVue(app)

// Commit this bundle was built from. Set before mount so it is present before any
// router redirect; the smoke suite reads it to prove which build actually ran.
window.__EDUTRAK_BUILD__ = __EDUTRAK_BUILD__

app.mount('#app')

// @ts-ignore
window.tsepHandler = (eventType, event) => {
  window.errorMsg = ''
  window.tsepToken = ''
  window.last4 = ''
  window.expDate = ''
  window.cardType = ''
  window.responseCode = event.responseCode
  if (event.responseCode == 'TSEP001' || event.responseCode == 'D2005') {
    window.errorMsg =
      'Invalid credit card number. If you are having trouble saving the credit card, please reload the form.'
  }
  if (eventType == 'TokenEvent' && event.tsepToken != '' && event.tsepToken != null) {
    window.tsepToken = event.tsepToken
    window.last4 = event.maskedCardNumber
    window.expDate =
      event.expirationDate.substring(3, 7) + '-' + event.expirationDate.substring(0, 2)
    window.cardType = event.cardType
  }
  // keep this comment for reference purposes
  //console.debug('Event Type ' + String(eventType) + ' Event - ' + JSON.stringify(event))
}
